export const CREATE_BANK_PAYMENT_SLIP_ENTRY  = 'CREATE_BANK_PAYMENT_SLIP_ENTRY';
export const GET_BANK_PAYMENT_SLIP_ENTRIES  = 'GET_BANK_PAYMENT_SLIP_ENTRIES';
export const BANK_PAYMENT_SLIP_ENTRY_REQUEST  = 'BANK_PAYMENT_SLIP_ENTRY_REQUEST';
export const DELETE_BANK_PAYMENT_SLIP_ENTRY  = 'DELETE_BANK_PAYMENT_SLIP_ENTRY';
export const UPDATE_BANK_PAYMENT_SLIP_ENTRY  = 'UPDATE_BANK_PAYMENT_SLIP_ENTRY';
export const BANK_PAYMENT_SLIP_ENTRY_REQUEST_FAILURE  = 'BANK_PAYMENT_SLIP_ENTRY_REQUEST_FAILURE';
export const GET_BANK_PAYMENT_SLIP_ENTRY_PAGE  = 'GET_BANK_PAYMENT_SLIP_ENTRY_PAGE';
export const GET_AVAILABLE_BANK_PAYMENT_TRANSACTION  = 'GET_AVAILABLE_BANK_PAYMENT_TRANSACTION';
export const BANK_PAYMENT_SLIP_ENTRY_REQUEST_SUCCESS  = 'BANK_PAYMENT_SLIP_ENTRY_REQUEST_SUCCESS';